
<nav class="toolbar">
  <v-app-bar flat height="80" color="darkblue" app class="top-navbar pa-0">
    <v-container class="py-0 px-md-6 fill-height">
      <v-row no-gutters align="center">
        <router-link to="/Home" exact>
          <img src="/assets/images/bw-legal-logo-inverted.svg" width="97px" height="26px" class="logo" alt="BW Legal Logo" />
        </router-link>
        <v-toolbar-title class="ml-1 top-navbar__brand">
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="hidden-md-and-down top-navbar__desktop-actions">
          <v-tabs
            background-color="transparent"
            color="transparent"
            slider-color="transparent"
            hide-slider
            class="top-navbar__tabs"
          >
            <v-tab
              v-for="(item, index) in menuItems"
              :key="index"
              :to="{ name: item.route }"
              exact
              class="top-navbar__tab"
            >
              {{ item.title }}
            </v-tab>
          </v-tabs>
          <v-btn :to="{ name: 'HowCanIPay' }" color="primary" outlined large class="ml-4">
            Make a Payment
          </v-btn>
        </div>
        <v-app-bar-nav-icon dark @click.stop="sidebar = !sidebar" class="hidden-lg-and-up"></v-app-bar-nav-icon>
      </v-row>
    </v-container>
  </v-app-bar>
  <div class="hidden-lg-and-up">
    <v-navigation-drawer
      v-model="sidebar"
      temporary
      height="100%"
      color="darkblue"
      dark
      app>
    <v-list>
        <v-list-item-group color="primary">
          <div v-for="(item, index) in sidebarItems" :key="index">
            <v-list-item
              v-if="item.subLinks.length === 0"
              :to="{ name: item.route }"
              exact
              link>
              <v-list-item-icon>
                <v-icon>{{ getNavIcon(item.route) }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-list-item-group>
    </v-list>
    <template v-slot:append>
      <div class="pa-2">
        <v-btn block color="primary" outlined large :to="{ name: 'PaymentPortal' }">
          Make a payment
        </v-btn>
      </div>
    </template>
    </v-navigation-drawer>
  </div>
</nav>
